import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Row, Col, Card} from 'antd';

import _ from 'lodash';

import * as actions from '../redux/actions';
import PersonPictograph from "../charts/PersonPictograph";
import StateSelector from "../charts/StateSelector";
import ageIcon from '../images/icon-age.svg';
import pillIcon from '../images/icon-pill.svg';
import hospitalIcon from '../images/icon-hospital.svg';

import './CountyDetailCard.css';

const maRateProp = 'BDC3';
const pctMaleProp = 'BDC6';
const pctFemaleProp = 'BDC5';
const avgAgeProp = 'BDC4';
const avgHccProp = 'BDC12';
const mcAvgProp = 'BDC11';


class CountyDetailCard extends Component {
  render() {
    const year = this.props.year;
    const yearIndex = 2015 - (year || 2015);
    const getDataValue = prop => {
      return _.get(this.props.data, [prop, yearIndex], 0);
    };

    return (
      <div className="CountyDetailCard">
        <Card noHovering={true}>
          <Row gutter={20}>
            <Col xs={24} md={6}>
              {!this.props.hideSelector &&
              <StateSelector
                maxHeight={200}
                dict={this.props.countyDict}
                stateFips={this.props.selectedState.fips}
                selectedCounty={this.props.selectedCounty.fips}
                onClick={this.props.actions.selectCounty}
              />
              }
            </Col>
            <Col xs={24} md={18}>
              <Row gutter={this.props.hideSelector ? 4 : 28}>
                <h1 className="title">
                  {this.props.selectedCounty.name} County {this.props.selectedState.abbr} Health Dimensions
                </h1>
                <Col xs={24} sm={8}>
                  <PersonPictograph
                    className="red"
                    value={getDataValue(maRateProp)}
                    personCount={10}
                    total={100}
                    label={`MA Participation Rate ${this.props.year}\n`}
                    description={'County Percent of Part A and Part B beneficiaries who are in enrolled in a MA program'}
                  />
                </Col>
                <Col xs={12} sm={8}>
                  <PersonPictograph
                    className="blue"
                    value={getDataValue(pctMaleProp)}
                    personCount={10}
                    total={100}
                    label={`Percent Male ${this.props.year}\n`}
                    description={'County Percent of Medicare fee-for-service beneficiaries who are male'}
                  />
                </Col>
                <Col xs={12} sm={8}>
                  <PersonPictograph
                    className="pink"
                    value={getDataValue(pctFemaleProp)}
                    personCount={10}
                    total={100}
                    label={`Percent Female ${this.props.year}\n`}
                    description={'County Percent of Medicare fee-for-service beneficiaries who are female'}/>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
        <Row gutter={18}>
          <Col xs={24} md={8}>
            <Card className="kpi" noHovering={true}>
              <img src={ageIcon} alt="age icon"/>
              <h2 className="subtitle">
                County Average age of Medicare fee-for-service beneficiaries {this.props.year}
              </h2>
              <h1 className="title">
                {getDataValue(avgAgeProp)} Years Old
              </h1>
            </Card>
          </Col>
          <Col xs={24} md={8}>
            <Card className="kpi" noHovering={true}>
              <img src={pillIcon} alt="health icon"/>
              <h2 className="subtitle">
                County Average Hierarchical Condition Category (HCC) Score {this.props.year}
              </h2>
              <h1 className="title">
                {getDataValue(avgHccProp)} Risk Score
              </h1>
            </Card>
          </Col>
          <Col xs={24} md={8}>
            <Card className="kpi" noHovering={true}>
              <img src={hospitalIcon} alt="hospital icon"/>
              <h2 className="subtitle">
                County Medicare FFS beneficiaries who are eligible for Medicaid {this.props.year}
              </h2>
              <h1 className="title">
                {getDataValue(mcAvgProp)} Percent
              </h1>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

function mapStoreToProps(store, props) {
  const countyFips = _.get(store, ['counties', 'selected', 'fips']);
  const countyData = _.get(store, ['counties', 'dict', countyFips], {});
  const countyPerc = _.get(store, ['counties', 'percentileDict', countyFips], {});

  return {
    loading: store.states.loading || store.dimensions.loading,
    year: store.dimensions.year,
    selectedState: store.states.selected,
    selectedCounty: store.counties.selected,
    data: countyData,
    countyDict: store.counties.dict,
    percentiles: countyPerc,
    hideSelector: props.hideSelector
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStoreToProps, mapDispatchToProps)(CountyDetailCard);



// WEBPACK FOOTER //
// ./src/containers/CountyDetailCard.js